export const createSelectionActions = (set, get) => ({

  getSelectedProduct: () => {
    return get().selectedProduct;
  },

  setSelectedProduct: (product) => {
    set({ selectedProduct: product });
  },

  clearSelectedProduct: () => {
    set({ selectedProduct: null });
  },
});
